// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section class="box">
  <sub-header header="'Manage borrowers'"></sub-header>
    <div class="filters">
      <span class="label">Add customer</span>
      <customer-picker on-choose="\$ctrl.addBorrower(customer)"></customer-picker>
    </div>

    <table class="table" ng-table="\$ctrl.borrowersTable">
      <thead>
        <tr>
          <th>No.</th>
          <th>CIF No.</th>
          <th>Customer name</th>
          <th>Birth date</th>
          <th>Loans</th>
          <th>Active Loans</th>
          <th>Principal Amount</th>
          <th>Principal Balance</th>
          <th></th>
        </tr>
      </thead>

      <tbody>
        <tr ng-repeat="item in \$data">
          <td>{{\$index + 1 + (\$ctrl.borrowersTable.page() - 1) * \$ctrl.borrowersTable.count() }}</td>
          <td>{{item.customerNumber}}</td>
          <td>{{item.effectiveName}}</td>
          <td>{{item.individualData.birthDate | prettyDate}}</td>
          <td>{{item.totalLoans}}</td>
          <td>{{item.activeLoans}}</td>
          <td>{{item.principalAmount | nxCurrency}}</td>
          <td>{{item.principalBalance | nxCurrency}}</td>
          <td>
            <button class="btn btn-danger" ng-click="\$ctrl.removeBorrower(item)" type="button">Remove</button>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="clearfix"></div>
    <div class="flex-end">
      <button class="btn btn-warning" ng-click="\$ctrl.redirectBack()">Cancel</button>
      <button class="btn btn-primary" ng-click="\$ctrl.manageBorrowers()">Update</button>
    </div>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/credit-line/borrowers/customer-credit-line-borrowers.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;